import React from 'react';

const SideBarLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="25"
      viewBox="0 0 68 25"
      fill="none"
    >
      <g clipPath="url(#clip0_1634_6703)">
        <path
          d="M31.2883 6.17676H26.9951V19.1861H31.2883V6.17676Z"
          fill="#7950FF"
        />
        <path
          d="M29.1444 0.0292969C27.6743 0.0292969 26.4736 1.03047 26.4736 2.25412C26.4736 3.48363 27.6743 4.4848 29.1444 4.4848C30.6145 4.4848 31.8152 3.48363 31.8152 2.25412C31.8152 1.03047 30.6145 0.0292969 29.1444 0.0292969Z"
          fill="#7950FF"
        />
        <path
          d="M25.3789 6.17682H21.0857C20.992 8.49532 19.4458 10.7553 17.595 11.0246V1.56909H13.3018V19.1862H17.595V14.3677C19.5922 14.5023 20.992 16.8677 21.0857 19.1862H25.3789C25.3379 17.5937 24.8108 15.8314 23.9791 14.5316C23.4578 13.7119 22.5383 13.226 21.566 13.226H20.2423L20.2365 12.3302H21.6363C22.5441 12.3302 23.411 11.9145 23.9381 11.1827C25.1095 9.57261 25.3555 7.44731 25.3789 6.17682Z"
          fill="#7950FF"
        />
        <path
          d="M68.0066 6.17676H63.7193V13.2318C63.7193 14.2447 63.4323 15.6557 61.7982 15.6557C60.5975 15.6557 59.6194 14.9765 59.6194 13.4894V6.17676H55.3262V14.2271C55.3262 17.658 57.259 19.5081 60.1758 19.5081C63.5436 19.5081 63.6783 16.4754 63.6783 16.4754L64.3167 16.4695L64.3284 17.295C64.3284 18.9929 63.403 20.9309 60.0352 20.9309C57.7978 20.9309 56.4097 20.2693 56.4097 20.2693V23.9168C56.4097 23.9168 58.0028 25.0116 60.5565 25.0116C66.3432 25.0116 68.0008 20.8138 68.0008 16.9964V6.17676H68.0066Z"
          fill="#7950FF"
        />
        <path
          d="M4.57433 9.85942C4.57433 9.37933 4.92575 8.99877 5.60516 8.99877C6.33729 8.99877 6.78828 9.473 6.78828 10.3395H11.4798C11.4798 6.70954 8.15882 5.85474 5.69302 5.85474C2.4248 5.85474 -0.0117188 7.336 -0.0117188 9.66621C-0.0117188 14.7775 7.05185 13.0737 7.05185 15.3688C7.05185 16.0011 6.50714 16.3056 5.82773 16.3056C4.62704 16.3056 4.51576 15.4215 4.51576 15.0585H-0.00586137C-0.00586137 18.3957 2.94022 19.5081 5.8453 19.5081C9.64651 19.5081 11.7375 18.1381 11.7375 15.4508C11.7316 10.925 4.57433 12.3828 4.57433 9.85942Z"
          fill="#7950FF"
        />
        <path
          d="M53.258 1.56909H48.9648V19.1862H53.258V1.56909Z"
          fill="#7950FF"
        />
        <path
          d="M42.223 5.85474C38.9255 5.85474 38.2871 8.89923 38.2871 8.89923H37.6662V6.17675H33.373V23.7938H37.6545H37.6662V16.4695H38.3164C38.3164 16.4695 38.4511 19.514 42.0297 19.514C45.0578 19.514 47.424 16.8852 47.424 12.7458C47.424 9.28565 46.0652 5.85474 42.223 5.85474ZM40.501 15.5796C39.1422 15.5796 38.0352 14.2739 38.0352 12.6756C38.0352 11.0714 39.1422 9.7716 40.501 9.7716C41.8599 9.7716 42.9668 11.0772 42.9668 12.6756C42.9668 14.2798 41.8599 15.5796 40.501 15.5796Z"
          fill="#7950FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1634_6703">
          <rect width="68" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideBarLogo;
